/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { marketSizeInvestorsDtoSchema } from "./marketSizeInvestorsDtoSchema.ts";
import { marketSizeStartupsDtoSchema } from "./marketSizeStartupsDtoSchema.ts";
import { z } from "zod/v4";

export const marketSizeDtoSchema = z.object({
  get investors() {
    return marketSizeInvestorsDtoSchema.optional();
  },
  get startups() {
    return marketSizeStartupsDtoSchema.optional();
  },
});
